/* eslint-disable no-console */
import {
  useFeatureFlagEnabled,
  useFeatureFlagVariantKey,
  usePostHog,
} from 'posthog-js/react'

export const useWrappedPosthog = () => {
  const posthog = usePostHog()

  const _capture = (...args) => {
    // console.log('PostHog_capture', {
    //   _capture: args,
    // })
    try {
      if (posthog && posthog.capture) return posthog.capture(...args)
    } catch (error) {
      console.log('PostHog', {
        message: 'Error while capturing PostHog',
        error,
      })
    }
  }
  const _identify = (...args) => {
    // console.log('PostHog_identify', {
    //   _identify: args,
    // })
    try {
      if (posthog && posthog.identify) return posthog.identify(...args)
    } catch (error) {
      console.log('PostHog', {
        message: 'Error while identifying PostHog',
        error,
      })
    }
  }
  const _useFeatureFlagEnabled = (...args) => {
    // console.log('PostHog_useFeatureFlagEnabled', {
    //   _useFeatureFlagEnabled: args,
    // })
    try {
      if (useFeatureFlagEnabled) return useFeatureFlagEnabled(...args) || false
    } catch (error) {
      console.log('PostHog', {
        message: 'Error while useFeatureFlagEnabled PostHog',
        error,
      })
    }
  }
  const _useFeatureFlagVariantKey = (...args) => {
    // console.log('PostHog_useFeatureFlagVariantKey', {
    //   _useFeatureFlagVariantKey: args,
    // })
    try {
      if (useFeatureFlagVariantKey)
        return useFeatureFlagVariantKey(...args) || ''
    } catch (error) {
      console.log('PostHog', {
        message: 'Error while _useFeatureFlagVariantKey PostHog',
        error,
      })
    }
  }

  return {
    capture: _capture,
    identify: _identify,
    useFeatureFlagEnabled: _useFeatureFlagEnabled,
    useFeatureFlagVariantKey: _useFeatureFlagVariantKey,
    config: posthog.config,
  }
}
